import { environment } from '../environments/environment'
import axios from 'axios'

// Set config defaults when creating the instance
const instance = axios.create({
  baseURL: environment.baseUrl,
})
instance.defaults.headers['Content-Type'] = 'application/json'

instance.interceptors.response.use(
  (value) => {
    return value.data
  },
  (error) => {
    throw error
  },
)

export default instance
